import { IncidentRosterPerson } from '../Types/Incident';

const normalized = (value?: string | null): string => (value ?? '').trim().toLowerCase();

/** Email is a linking hint; these records remain separate and require explicit selection. */
export const getAccountingSource = (person: IncidentRosterPerson): 'employeeBadge' | 'lobbyTrack' | undefined => {
  const type = normalized(person.personType);
  if (person.isUnlisted || type === 'tenant' || type === 'contractor' || person.rosterSource === 'manualAdd') return undefined;
  if (person.rosterSource === 'lobbyTrack') return 'lobbyTrack';
  const badgeType = normalized(person.lastIncidentDayBadgeActivity?.badgeType);
  if ((type === 'employee' || badgeType === 'employeebadge')
    && (person.rosterSource === 'badgeData' || person.inclusionReasons?.includes('badgeData'))) return 'employeeBadge';
  return undefined;
};

/** The caller must supply a complete roster for exactly one incident. */
export const findLinkedAccountingPeople = (
  person: IncidentRosterPerson,
  incidentRoster: IncidentRosterPerson[],
): IncidentRosterPerson[] => {
  const email = normalized(person.email);
  const source = getAccountingSource(person);
  if (!email || !source) return [];
  const seen = new Set<string>([person.personId]);
  return incidentRoster.filter((candidate) => {
    const candidateSource = getAccountingSource(candidate);
    if (seen.has(candidate.personId) || normalized(candidate.email) !== email
      || !candidateSource || candidateSource === source) return false;
    seen.add(candidate.personId);
    return true;
  });
};
